import {StageApi} from 'modules/api/stage';
import {CentrifugeApi} from 'modules/api/centrifuge';
import {I18nDataLoader} from 'modules/api/i18n-anonymous.js';
import {GameVarsApi} from 'modules/api/game-vars';
import {ScenarioApi} from 'modules/api/scenario';
import {centrifugeModule} from 'us-csg-game-common';
import {BetApi} from 'modules/api/bet';
import {ConsoleApi} from 'modules/api/console';
import {ExerciseApi} from 'modules/api/exercise';
import {AuthApi} from 'modules/api/auth';

export const extraArgs = {
    authApi: new AuthApi(),
    betApi: new BetApi(),
    centrifugeApi: new CentrifugeApi(),
    centrifugeService: new centrifugeModule.CentrifugeService(),
    consoleApi: new ConsoleApi(),
    dataLoader: new I18nDataLoader(),
    exerciseApi: new ExerciseApi(),
    gameVarsApi: new GameVarsApi(),
    scenarioApi: new ScenarioApi(),
    stageApi: new StageApi(),
};
